import { ReactElement } from 'react';
import { captureMessage, Severity } from '@sentry/react';
import T from 'i18n-react';

export const getFbPhoneErrorText = (
  code: string | null,
): ReactElement | string => {
  switch (code) {
    case 'auth/invalid-phone-number':
      // 電話番号が無効
      return T.translate('firebase.error.invalidPhoneNumber') as string;
    case 'auth/missing-phone-number':
      // 電話番号が未入力
      return T.translate('firebase.error.missingPhoneNumber') as string;
    case 'auth/invalid-verification-code':
      // 確認コードが一致しない
      return T.translate('firebase.error.invalidVerificationCode') as string;
    case 'auth/code-expired':
      // 確認コードの期限切れ、使用済み
      return T.translate('firebase.error.codeExpired') as string;
    case 'auth/too-many-requests':
      // 送信回数を上限に達した
      return T.translate('firebase.error.tooManyRequests') as string;
    case 'auth/account-exists-with-different-credential':
    case 'auth/credential-already-in-use':
    case 'auth/provider-already-linked':
      // 電話番号が認証済み
      return (
        <span>
          {T.translate('firebase.error.accountExistsWithDifferentCredential', {
            here: (
              <a
                href="https://support.otetsutabi.com/hc/ja/articles/5670321660697"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                {T.translate('firebase.error.here')}
              </a>
            ),
          })}
        </span>
      );
    default:
      if (code != null && code !== 'auth/captcha-check-failed') {
        // リキャプチャ認証失敗以外のエラーは想定外や緊急度が高いので、Sentry へ送信する。
        // Firebase は公式ドキュメントに記載していないエラーコードも返すため、リアルタイムでコードを検知するために送信している。
        captureMessage(
          `Uncaught firebase error code '${code}' thrown`,
          Severity.Warning,
        );
      }
      return T.translate('firebase.error.default') as string;
  }
};
